import { Link } from "react-router-dom";
import { PageBody } from "../ui/Field";

export default function NotFound() {
  return (
    <PageBody className="max-w-3xl">
      <div className="text-center py-20 reveal reveal-1">
        <div className="section-no mb-6">№ 404 · Not found</div>
        <h1 className="display text-[140px] md:text-[200px] leading-none text-[var(--color-accent)] mb-4">
          <em>404</em>
        </h1>
        <hr className="rule mx-auto w-32 my-8" />
        <p className="text-[15px] text-[var(--color-muted)] max-w-md mx-auto mb-8">
          The page you were looking for has been moved, retired, or never existed in the first place.
        </p>
        <Link
          to="/"
          className="inline-flex h-9 items-center px-4 rounded-[var(--radius-sm)] bg-[var(--color-ink)] text-[var(--color-paper)] text-[13.5px] no-underline hover:bg-[var(--color-ink-2)] transition-colors"
        >
          ← Return home
        </Link>
      </div>
    </PageBody>
  );
}
